import { KonfioTyC } from "components/oferta-digital/cotizacion/referersTyC/konfioTyC";
import { WorkyTyC } from "components/oferta-digital/cotizacion/referersTyC/workyTyC";

export const refererListData = {
  'Konfio': {
    logo: '/assets/oferta-digital/partners/konfio-logo.png',
    color: '#773DBE',
    secondaryColor: '#9795d6',
    backgroundColor: '#F9F9F9',
    tyc: <KonfioTyC />,
    banner: {
      title: 'Sí Vale y Konfío te da la bienvenida a la plataforma online de vales en México',
      content: 'Por ser cliente Konfío, obtén beneficios adicionales para tu empresa. Cotiza gratis tus Vales de Despensa, Vales de Gasolina,  Crédito de incentivos para empleados.',
      contentBold: '¡Descubre todo lo que puedes hacer con las soluciones Sí Vale!',
      logoText: 'Sin costo de inscripción y 50% de descuento en tarjetas titulares *',
      disclaimer: '*el descuento aplica únicamente  para la primera emisión de tarjetas titulares.',
    },
    quotation: {
      disclaimer: 'El descuento en el costo de las tarjetas titulares aplica únicamente para el primer pedido.',
      disclaimerBold: 'La vigencia de esta cotización es de 60 días naturales a partir de la fecha en que fue generada.',
      logo: '/assets/oferta-digital/partners/konfio-discount-logo.png',
      discount: {
        inscription: {
          text: 'Costo de Inscripción Konfío',
          value: 1, // inscription discount value : 1 = 100%
        },
        cards: {
          text: 'Costo especial Konfío en tarjetas',
          value: 0.5, // cards cost discount value : 0.5 = 50%
          tooltip: 'Costo especial Konfío $32.50 por tarjeta titular',
        }
      }
    }
  },
  'Worky': {
    logo: '/assets/oferta-digital/partners/worky-logo.png',
    color: '#0093FF',
    secondaryColor: '#006EBD',
    backgroundColor: '#F9F9F9',
    tyc: <WorkyTyC />,
    banner: {
      title: 'Sí Vale y Worky te da la bienvenida a la plataforma online de vales en México',
      content: 'Por ser cliente Worky, obtén beneficios adicionales para tu empresa. Cotiza gratis tus Vales de Despensa, Vales de Gasolina, Crédito de incentivos para empleados.',
      contentBold: '¡Descubre todo lo que puedes hacer con las soluciones Sí Vale!',
      logoText: '50% de descuento en tarjetas titulares.*',
      disclaimer: '*El descuento aplica únicamente para la primera emisión de tarjetas titulares.',
    },
    quotation: {
      disclaimer: 'Descuento en costo de las tarjetas aplica para el primer pedido y tarjetas.',
      disclaimerBold: 'La vigencia de esta cotización es de 60 días a partir de la fecha en que fue generada.',
      logo: '/assets/oferta-digital/partners/worky-discount-logo.png',
      discount: {
        cards: {
          text: 'Costo especial Worky en tarjetas',
          value: 0.5,
          tooltip: 'Costo especial Worky $32.50 por tarjeta titular',
        }
      }
    }
  }
}
